import React from 'react'
import PropTypes from 'prop-types'

function PartnerBoxImageOnly({ partner, imgPath }) {
  return (
    <div className="col-12 col-sm-6 col-md-3 partners-tier-container__partner">
      <div className="card card--interactive">
        <a href={partner.url} className="link--primary-dark" target="_blank">
          <img src={imgPath} alt={partner.name} />
        </a>
      </div>
    </div>
  )
}

PartnerBoxImageOnly.propTypes = {
  partner: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  imgPath: PropTypes.string.isRequired,
}

export default PartnerBoxImageOnly
